import { createWebHashHistory, createRouter } from "vue-router";

const Dashboard = () =>
  import(/* webpackChunkName: "account" */ "@/views/account/Dashboard.vue");
const OrderHistory = () =>
  import(
    /* webpackChunkName: "order-history" */ "@/views/account/OrderHistory.vue"
  );
const YourBenefits = () =>
  import(
    /* webpackChunkName: "your-benefits" */ "@/views/account/YourBenefits.vue"
  );
const Order = () =>
  import(/* webpackChunkName: "order" */ "@/views/account/Order.vue");
const OrderTrack = () =>
  import(
    /* webpackChunkName: "order-track" */ "@/views/account/OrderTrack.vue"
  );
const Returns = () =>
  import(/* webpackChunkName: "returns" */ "@/views/account/Returns.vue");
const Return = () =>
  import(/* webpackChunkName: "Return" */ "@/views/account/Return.vue");
const Wishlist = () =>
  import(/* webpackChunkName: "wishlist" */ "@/views/account/Wishlist.vue");

const routes = [
  { path: "/", name: "Dashboard", component: Dashboard },
  { path: "/orders", name: "OrderHistory", component: OrderHistory },
  { path: "/order/:id", name: "Order", component: Order },
  {
    path: "/order/:id/track",
    name: "OrderTrack",
    component: OrderTrack,
  },
  { path: "/returns", name: "Returns", component: Returns },
  { path: "/return/:id", name: "Return", component: Return },
  { path: "/wishlist", name: "Wishlist", component: Wishlist },
  { path: "/your-benefits", name: "YourBenefits", component: YourBenefits },
];

const router = createRouter({
  history: createWebHashHistory(window.location.pathname + "/"),
  routes,
});

export default router;
